<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <table
         class="table-bordered table-full-width border-primary"
         cellpadding="20">
          <tr>
            <td>
              <h4 class="card-title">Budget</h4>
              <a :href="downloadFiles[0][$i18n.locale]" class="btn btn-simple btn-primary">
                {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
              </a>

              <div class="form-group">
                <span class="file-caption" v-if="!GrantForm.files.budget.appCompletedBudgetTable">{{$t('small_technical_grants.document_upload__budget_upload_title_1')}}</span>
                <upload-file
                  v-if="GrantForm.initialized"
                  v-model="GrantForm.files.budget.appCompletedBudgetTable"
                  class="upload-file"
                  :file-data="GrantForm.files.budget.appCompletedBudgetTable"
                  :is-editable="GrantForm.isEditable"
                  :size-limit="GrantForm.fileSizeLimit"
                  section="budget.appCompletedBudgetTable"
                  >
                </upload-file>
              </div>
              </td>
            </tr>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <table class="mt-5 mb-2" width="100%">
          <thead>
            <th>Name</th>
            <th>Upload</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in GrantForm.model.budget.budgetOtherDocuments" :key="'result_'+index">
              <td>
                <textarea
                  class="form-control"
                  v-model="item.result"
                >
                </textarea>
              </td>
              <td>
                <upload-file
                  v-if="GrantForm.initialized"
                  v-model="GrantForm.files.budget['budgetOtherDocuments' + (index+1)]"
                  class="upload-file"
                  :file-data="GrantForm.files.budget['budgetOtherDocuments' + (index+1)]"
                  :is-editable="GrantForm.isEditable"
                  :size-limit="GrantForm.fileSizeLimit"
                  :section="'budget.budgetOtherDocuments' + (index + 1)"
                  >
                </upload-file>
              </td>
            </tr>
          </tbody>
        </table>

        <base-button
          type="primary"
          @click.native="addOtherDocument"
          class="ml-2 "
          >
          <i class="tim-icons icon-simple-add mr-2"></i> {{$t('small_technical_grants.logical_framework__add_row_button_title')}}
        </base-button>
        <span class="ml-3">{{$t('small_technical_grants.logical_framework__add_row_button_info')}}</span>
      </div>
    </div>

  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm,
        downloadFiles: [
          {
            en: '/files/en/MG/FP/Region/'+GrantForm.regionId+'/budget_template.xls',
            fr: '/files/fr/MG/FP/Region/'+GrantForm.regionId+'/budget_template.xls'
          },
        ]
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      addOtherDocument()
      {
        if (!GrantForm.model.budget.budgetOtherDocuments)
        {
          GrantForm.model.budget.budgetOtherDocuments = [];
        }

        GrantForm.model.budget.budgetOtherDocuments.push({});
        this.$forceUpdate();
      },
      mounted()
      {
        this.addOtherDocument();
      },
    }
  }
</script>
<style lang="scss" scoped>
.table-bordered td,
.table-bordered th
{
  padding: 20px;
}

.file-caption
{
  margin-right: 10px;
  display: inline-block;
  width: 60%;
}

.upload-file
{
  display: inline-block;
  margin-bottom: -4px;
}

.form-group
{
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 15px;
}

.card-title
{
  display: inline-block;
  width: 100%;
  margin-bottom: 1.75rem !important;
}
</style>
